var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconManeuvers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 91,
    viewBox: "0 0 104 91",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.3426 56.4483L97.577 91H12.0625L17.7648 78.8638C21.7751 77.7416 25.9251 76.5596 29.9723 75.3739L25.99 83.8492H73.1369L63.7041 63.7736C69.3305 61.5045 75.4274 58.9598 81.3426 56.4483ZM75.5974 44.2209L54.8198 0L26.8693 59.4867C31.5358 56.6587 36.3046 54.077 40.9352 52.0416L49.5634 33.6781L55.9344 47.2373C62.1855 45.8447 68.97 44.8823 75.5974 44.2209Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0578 56.9756C23.8412 65.2798 0 81.8881 0 81.8881C0 81.8881 29.2852 68.9705 48.0578 62.5117C66.8303 56.0529 104 44.75 104 44.75C104 44.75 72.2744 48.6714 48.0578 56.9756Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconManeuvers);
export default __webpack_public_path__ + "static/media/iconManeuvers.88d9541875d9f8c09e87c5456b12c17c.svg";
export { ForwardRef as ReactComponent };